import { render, staticRenderFns } from "./PurchaseUser.vue?vue&type=template&id=5ab2f846&"
import script from "./PurchaseUser.vue?vue&type=script&lang=js&"
export * from "./PurchaseUser.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseUser.vue?vue&type=style&index=0&id=5ab2f846&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports